import React from 'react';
import { useSelector } from 'react-redux';
import { Comments, FilesComponent, Notes, SimpleTabs } from 'components';
import { commentModels, fileEnums, noteModels, PermissionList, RolePermission } from 'utils';
import { invoiceDetailTabsLabels } from './constants';
import { InvoiceAppointments } from './invoiceAppointments';
import { HistoryTab } from '../../../history';
import { InvoiceDetailTab } from './invoiceDetailTab';
import { InvoiceDetailHeader } from './invoiceDetailHeader';
import { InvoiceTransactions } from './invoiceTransactions';
import { formModelEnums } from 'pages';

export const InvoiceDetailInfo = () => {
    const invoiceById = useSelector((state) => state.invoice.invoiceById);

    const invoiceTabContent = [
        {
            tabComponent: <InvoiceDetailTab />,
            tab: 'Details',
        },
        {
            tabComponent: <InvoiceAppointments />,
            tab: 'Appointments',
        },
        {
            tabComponent: <InvoiceTransactions />,
            tab: 'Transactions',
        },
        {
            tabComponent: (
                <Comments
                    fromDetail={true}
                    resource={commentModels.Invoice}
                    resourceId={invoiceById?.id}
                    label={'Invoice'}
                    width={700}
                    height={600}
                    attachmentPurpose={'invoice'}
                    enableAiImprove
                />
            ),
            tab: 'Comments',
        },
        RolePermission([PermissionList.INVOICE_NOTE_READ?.code, PermissionList.INVOICE_NOTE_MANAGE?.code]) && {
            tabComponent: (
                <Notes
                    id={invoiceById?.id}
                    onModel={noteModels.Invoice}
                    formModel={formModelEnums.INVOICENOTES}
                    permissions={[PermissionList.INVOICE_NOTE_MANAGE?.code]}
                />
            ),
            tab: 'Notes',
        },
        RolePermission([PermissionList.INVOICE_HISTORY_READ?.code]) && {
            tabComponent: <HistoryTab currentId={invoiceById?.id} onModel={'Invoice'} />,
            tab: 'History',
        },
        RolePermission([PermissionList.INVOICE_FILE_MANAGE?.code, PermissionList.INVOICE_FILE_READ?.code]) && {
            tabComponent: (
                <FilesComponent
                    currentId={invoiceById?.id}
                    onResource={fileEnums.INVOICE}
                    permissions={[PermissionList.INVOICE_FILE_MANAGE?.code]}
                />
            ),
            tab: 'Files',
        },
    ];

    return (
        <div className="tab-box-wrapper">
            <InvoiceDetailHeader />
            <SimpleTabs defaultTab={'Details'} tabsLabels={invoiceDetailTabsLabels} tabsContent={invoiceTabContent} />
        </div>
    );
};
